/**
 * A deterministic identicon: a 5×5 mirrored grid from a hash of the seed, in
 * one hue picked by the same hash. No uploads, nothing to moderate, and every
 * member — real, persona or resident — gets one the moment they exist.
 */
function hash(seed: string): number {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function Avatar({ seed, size = 32, title }: { seed: string; size?: number; title?: string }) {
  const h = hash(seed);
  const hue = h % 360;
  const cells: Array<[number, number]> = [];
  for (let row = 0; row < 5; row++) {
    for (let col = 0; col < 3; col++) {
      if ((h >> (row * 3 + col)) & 1) {
        cells.push([col, row]);
        if (col < 2) cells.push([4 - col, row]);
      }
    }
  }
  return (
    <svg
      className="avatar"
      width={size}
      height={size}
      viewBox="-1 -1 7 7"
      // Named only when it stands alone; next to a name it is decoration, and
      // an "avatar" label would be read out in front of every member's name.
      {...(title ? { role: "img", "aria-label": title } : { "aria-hidden": true })}
      style={{ background: `hsl(${hue} 30% 16%)` }}
    >
      {cells.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="1.02" height="1.02" fill={`hsl(${hue} 70% 58%)`} />
      ))}
    </svg>
  );
}
